import React, { Component } from 'react'
import Header from '../Header'
import './XIIs.css'

class XIIs extends Component {
  
    render () {
        return (
            <div>
                <Header />
                <div className="bodyXIIs">
                    <p className="textXII">1940 - Jeux attribués à Tokyo, Japon. Annulés à cause de la Seconde Guerre mondiale.</p>
                </div>
            </div>
        )
    }
}

export default XIIs